import React, { FunctionComponent } from 'react';

import Icon from '../../components/Icons';

export const formatIconName = (name: string) => {
  if (!name) {
    return '';
  }
  return name.toLowerCase().split(' ').join('-');
};

const MenuIcon: FunctionComponent<{ name: string; path?: string; type?: string; tag?: string }> = ({
  name,
  path,
  type,
  tag,
}) =>
  type === 'svg' ? (
    <div className="item-image-wrapper">
      {tag ? <span className="tag">{tag}</span> : null}
      <Icon name={formatIconName(name)} path={path} />
    </div>
  ) : (
    <div className="item-image-wrapper">
      <i className="material-icons">{name}</i>
    </div>
  );

export default MenuIcon;
